export const GET_ENTITIES_DICTIONARIES_REQUEST =
  'GET_ENTITIES_DICTIONARIES_REQUEST';
export const GET_ENTITIES_DICTIONARIES_SUCCESS =
  'GET_ENTITIES_DICTIONARIES_SUCCESS';
export const GET_ENTITIES_DICTIONARIES_ERROR =
  'GET_ENTITIES_DICTIONARIES_ERROR';
export const GET_ENTITIES_CONNECTED_DICTIONARIES_REQUEST =
  'GET_ENTITIES_CONNECTED_DICTIONARIES_REQUEST';
export const GET_ENTITIES_CONNECTED_DICTIONARIES_SUCCESS =
  'GET_ENTITIES_CONNECTED_DICTIONARIES_SUCCESS';
export const GET_ENTITIES_CONNECTED_DICTIONARIES_ERROR =
  'GET_ENTITIES_CONNECTED_DICTIONARIES_ERROR';
